var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#110A1D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2156_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7115 12.6486C23.9987 10.3003 21.7515 8.96884 18.7944 8.625C20.1778 10.2271 21.1293 11.9609 21.7369 13.8996C23.1203 13.6143 24.4305 13.2412 25.7115 12.6486Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3126 14.9036C12.7875 14.7663 12.2775 14.6329 11.7749 14.4775C11.3257 14.3326 10.8826 14.1667 10.4397 14.0009C10.1896 13.9073 9.93967 13.8138 9.68876 13.724C8.20286 16.3357 8.34194 20.0447 9.68144 22.2321C10.43 21.9969 11.1724 21.7616 11.9216 21.5243L11.923 21.5238C12.5945 21.3111 13.2718 21.0965 13.9634 20.8787C13.5682 18.9766 13.5755 17.0161 13.9708 15.0774C13.7484 15.0176 13.5292 14.9603 13.3126 14.9036Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1823 14.4481C23.4687 14.6749 22.7544 14.9018 22.0371 15.1286C22.4324 17.0453 22.4177 18.9913 22.0371 20.8714C23.4864 21.3323 24.8991 21.7785 26.3264 22.2248C27.7318 19.8179 27.7172 16.1601 26.3264 13.7679C25.6093 13.9946 24.8958 14.2214 24.1823 14.4481Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1493 20.7836C14.7393 18.9254 14.754 17.1038 15.1273 15.2822C15.4258 15.2998 15.719 15.3206 16.0085 15.3412C16.6845 15.3892 17.3407 15.4359 17.9966 15.4359C18.6525 15.4359 19.3084 15.3893 19.9843 15.3412C20.2738 15.3206 20.5675 15.2998 20.8659 15.2822C21.2685 17.0746 21.2539 18.9108 20.8586 20.7763C18.9408 20.5276 17.067 20.5129 15.1493 20.7836Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7116 23.3441C24.0134 25.6924 21.759 27.0165 18.8018 27.375C20.1633 25.7802 21.1368 24.0537 21.7297 22.1077C23.1058 22.3711 24.4087 22.7661 25.7116 23.3441Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1987 8.625C14.2415 8.97615 11.9871 10.3076 10.2303 12.7291C11.6064 13.1534 12.902 13.5557 14.2415 13.9727C14.8637 11.9463 15.8299 10.2271 17.1987 8.625Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1987 27.375C14.2488 27.0238 12.0017 25.6997 10.2303 23.2709C10.6691 23.1356 11.0996 23.0026 11.526 22.8708L11.5278 22.8703C12.4382 22.5889 13.3297 22.3134 14.2415 22.0346C14.8637 24.0391 15.8153 25.7729 17.1987 27.375Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.551 14.0752C20.002 12.356 19.1602 10.8563 17.9964 9.49557C16.8252 10.8782 15.9762 12.3706 15.4491 14.0752C17.1693 14.3019 18.8382 14.3093 20.551 14.0752Z",
    fill: "#9DADF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0037 26.5044C16.8399 25.151 15.9981 23.6513 15.4491 21.9321C17.1546 21.6907 18.8235 21.698 20.5583 21.9248C20.0093 23.6367 19.1675 25.1291 18.0037 26.5044Z",
    fill: "#9DADF2"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#9DADF2",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2156_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLanguage);
export default __webpack_public_path__ + "static/media/Btn. - Language.deec3e89b074f8f78ce950f603ecc197.svg";
export { ForwardRef as ReactComponent };